import React from 'react';
import { createRoot } from 'react-dom/client';
import WasmApp from './components/WasmApp';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<WasmApp />); 